import { motion } from 'framer-motion';

export default function Hero() {
  return (
    <section className="relative mx-auto max-w-6xl px-6 pt-32 pb-24">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <p className="font-mono text-xs text-accent uppercase tracking-widest mb-6">
          A field guide · May 2026
        </p>
        <h1 className="font-display text-5xl md:text-8xl tracking-tight2 leading-[0.95]">
          The lifecycle <br />
          has <span className="text-accent">changed</span>.
        </h1>
        <p className="mt-8 text-xl md:text-2xl text-ink-dim max-w-3xl">
          You already know how to ship software. This is for the next transformation —
          told stage by stage, for the people who led the last one.
        </p>
        <div className="mt-12 flex flex-wrap gap-3 font-mono text-xs">
          {[
            'Agentic apps',
            'MCP',
            'Eval-driven CI',
            'AI Gateway',
            'AIBOM',
            'EU AI Act',
            'GEO',
            'Edge-native',
          ].map((t) => (
            <span key={t} className="px-3 py-1 rounded-full border hairline text-ink-dim">
              {t}
            </span>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
